import { useInstance, createRef, onMounted, onUpdated } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { useResizeObserver } from '../../hooks/useResizeObserver';
export function useScroll() {
  var instance = useInstance();
  var scrollRef = createRef();
  var wrapperRef = createRef();
  var isScroll = useState(false);
  var offset = useState(0);
  var enablePrev = useState(false);
  var enableNext = useState(false);
  onMounted(refresh);
  onUpdated(refresh);
  useResizeObserver(scrollRef, refresh);
  instance.watch('value', scrollActiveToView, {
    presented: true
  });
  function getLength() {
    var _instance$get = instance.get(),
      vertical = _instance$get.vertical;
    if (vertical) {
      return {
        scrollLength: scrollRef.value.offsetHeight,
        wrapperLength: wrapperRef.value.offsetHeight
      };
    }
    return {
      scrollLength: scrollRef.value.offsetWidth,
      wrapperLength: wrapperRef.value.offsetWidth
    };
  }
  function refresh() {
    var _getLength = getLength(),
      scrollLength = _getLength.scrollLength,
      wrapperLength = _getLength.wrapperLength;
    isScroll.set(scrollLength < wrapperLength);
    updateTransition(offset.value, scrollLength, wrapperLength);
  }
  function updateTransition(_offset, scrollLength, wrapperLength) {
    var prev = true;
    var next = true;
    if (_offset >= 0) {
      _offset = 0;
      prev = false;
    } else if (_offset <= scrollLength - wrapperLength) {
      _offset = scrollLength - wrapperLength;
      next = false;
    }
    offset.set(_offset);
    enablePrev.set(prev);
    enableNext.set(next);
  }
  function prev() {
    var _getLength2 = getLength(),
      scrollLength = _getLength2.scrollLength,
      wrapperLength = _getLength2.wrapperLength;
    updateTransition(offset.value + scrollLength, scrollLength, wrapperLength);
  }
  function next() {
    var _getLength3 = getLength(),
      scrollLength = _getLength3.scrollLength,
      wrapperLength = _getLength3.wrapperLength;
    updateTransition(offset.value - scrollLength, scrollLength, wrapperLength);
  }
  function scrollActiveToView() {
    var _instance$get2 = instance.get(),
      vertical = _instance$get2.vertical;
    var k = instance.config.k;
    var activeTab = scrollRef.value.querySelector("." + k + "-tab." + k + "-active");
    if (activeTab) {
      var _offset = offset.value;
      // don't use getBoundingClientRect, it has transform and will return digital number
      var activeRect;
      var scrollRect;
      var wrapperRect;
      if (vertical) {
        activeRect = {
          offset: activeTab.offsetTop,
          length: activeTab.offsetHeight
        };
        scrollRect = {
          length: scrollRef.value.offsetHeight
        };
        wrapperRect = {
          offset: wrapperRef.value.offsetTop,
          length: wrapperRef.value.offsetHeight
        };
      } else {
        activeRect = {
          offset: activeTab.offsetLeft,
          length: activeTab.offsetWidth
        };
        scrollRect = {
          length: scrollRef.value.offsetWidth
        };
        wrapperRect = {
          offset: wrapperRef.value.offsetLeft,
          length: wrapperRef.value.offsetWidth
        };
      }
      var offsetDelta = activeRect.offset - wrapperRect.offset;
      if (_offset + offsetDelta <= 0) {
        _offset = -offsetDelta;
      } else if (offsetDelta + activeRect.length + _offset > scrollRect.length) {
        _offset = -offsetDelta - activeRect.length + scrollRect.length;
      }
      offset.set(_offset);
    } else {
      offset.set(0);
    }
  }
  return {
    isScroll: isScroll,
    offset: offset,
    enablePrev: enablePrev,
    enableNext: enableNext,
    prev: prev,
    next: next,
    scrollRef: scrollRef,
    wrapperRef: wrapperRef
  };
}